import { createContext, useContext, type ReactNode } from 'react';

type PageHeaderActionsPresentation = 'inline' | 'menu';

const PageHeaderActionsContext = createContext<PageHeaderActionsPresentation>('inline');

export function PageHeaderActionsProvider({
  children,
  presentation,
}: {
  children: ReactNode;
  presentation: PageHeaderActionsPresentation;
}) {
  return (
    <PageHeaderActionsContext.Provider value={presentation}>
      {children}
    </PageHeaderActionsContext.Provider>
  );
}

export function usePageHeaderActionsPresentation() {
  return useContext(PageHeaderActionsContext);
}
